module.exports = __webpack_public_path__ + "img/0747ff5.png";